module.exports = __webpack_public_path__ + "static/media/ehealth_calculator_banner_mobile.dd491ed3.png";